<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-card-text class="">
          <v-textarea
            label="Title"
            color="green"
            class="black--text"
            v-model="item.title"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
            required
          />
          <v-textarea
            label="What do they do?"
            color="green"
            v-model="item.what"
            :rows="2"
            :autoGrow="true"
            :hide-details="false"
            required
          />
          <v-textarea
            label="Who's their audience"
            color="green"
            v-model="item.audience"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
            required
          />

          <sub-items v-model="item.communications" name="sub">
            <v-label>What are their communications?</v-label>
            <p class="ma-0">
              Type in a communications format and press the
              <strong>Add</strong> button
            </p>
          </sub-items>
        </v-card-text>
      </v-col>
      <v-col cols="6">
        <v-card-text class="">
          <v-label>Add an Image</v-label>
          <upload @updatedSrc="getSrc" :preview="item"></upload>

          <!-- <v-select
            :items="$t(`${$route.meta.content}.dropdown`)"
            label="Clusters"
            v-model.trim="item.cluster"
            :rules="clusterRules"
            item-text="title"
            item-value="item"
            color="green"
            required
          ></v-select>

          <div v-show="item.cluster === 'Other'">
            <v-textarea
              label="Describe the look and feel"
              color="green"
              v-model="item.cluster_other"
              :rows="2"
              :autoGrow="true"
              :hide-details="false"
            />
          </div> -->

          <v-switch
            v-model="item.logo"
            color="green"
            inset
            label="Do they use the Etisalat logo?"
            :hide-details="true"
            class="mb-2"
          ></v-switch>
          <p class="ma-0 black--text body-1">{{ useLogo }}</p>

          <div v-show="!item.logo">
            <p>Describe why and how does it need to look different</p>
            <v-textarea
              label="Why?"
              color="green"
              v-model="item.logo_why"
              :rows="2"
              :autoGrow="true"
              :hide-details="false"
            />
          </div>

          <v-switch
            v-model="item.look"
            color="green"
            inset
            label="Do they use the Etisalat look &amp; feel?"
            :hide-details="true"
            class="mb-2"
          ></v-switch>

          <p class="ma-0 black--text body-1">{{ useLook }}</p>

          <div v-show="!item.look">
            <p>
              Describe why and how (close or far) it needs to look different?
            </p>
            <v-textarea
              label="Why?"
              color="green"
              v-model="item.look_why"
              :rows="2"
              :autoGrow="true"
              :hide-details="false"
            />
          </div>
        </v-card-text>
      </v-col>
    </v-row>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </div>
</template>

<script>
import SubItems from "@/views/user/exercises/attributes/SubItems";
import { Upload } from "@/components/functionality";

export default {
  name: "BrandArchitectureStep1Form",
  data() {
    return {
      item: this.value,
      clusterRules: [(v) => !!v || "Cluster is required"],
      isValidImage: false,
    };
  },
  props: {
    value: Object,
  },
  watch: {
    value: {
      handler: function(val) {
        this.item = val;
      },
      deep: true,
    },
  },
  components: {
    SubItems,
    Upload,
  },
  methods: {
    getSrc(val) {
      this.item.src = val;
    },
    validateImage(val) {
      this.isValidImage = val;
    },
  },
  computed: {
    useLogo() {
      return this.item.logo ? "Yes" : "No";
    },
    useLook() {
      return this.item.look ? "Yes" : "No";
    },
  },
};
</script>

<style lang="scss" scoped></style>
